import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import { ErrorBoundary } from './components/ErrorBoundary.jsx';
import './styles/colors_and_type.css';

// Entry point: mount the App into #root.
// In dev, React.StrictMode is helpful for catching accidental side effects.
// ErrorBoundary catches uncaught render errors anywhere in the tree so one
// broken component shows a recoverable message instead of unmounting the
// whole app to a blank page.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
